import $ from 'jquery';
class Counters {

    constructor() {
        $(document).ready(() => this.load());
    }

    load() {

        this.counters = document.querySelectorAll('[data-animatecounter]');

        const that = this;

        if ('IntersectionObserver' in window) {

            // IntersectionObserver Supported
            var config = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };

            var observer = new IntersectionObserver(onChange, config);
            this.counters.forEach(function(counter) { observer.observe(counter) });

            function onChange(changes, observer) {
                changes.forEach(function(change) {
                    if (change.intersectionRatio > 0) {
                        that.loadCounter(change.target);
                        observer.unobserve(change.target);
                    }
                });
            }

        } else {
            // IntersectionObserver NOT Supported
            this.counters.forEach(function(counter) {that.loadCounter(counter) });
        }

    }

    loadCounter(counter) {

        if(counter.dataset && counter.dataset.animatecounter) {
            counter.dataset.counterstatus = 0;
            this.updateCount(counter);
        }
    }


    updateCount(counter) {

        //Get parameters from current counter
        const target = parseFloat(counter.dataset.animatecounter);
        const speed = parseFloat(counter.dataset.speedcounter);
        const count = parseFloat(counter.dataset.counterstatus);
        const decimals = this.countDecimals(target);

        const inc = target / speed;
        const innerText = inc + count;

        //Set previous counter value as current value
        counter.dataset.counterstatus = innerText;

        //If new value is smaller than set value, incerement the counter
        if (count < target) {
            const incrementer = decimals > 0 ? Math.pow(10,decimals) : 1;
            counter.innerText = parseFloat(Math.round(innerText * incrementer) / incrementer).toLocaleString('nl');
            setTimeout(() => this.updateCount(counter), 1);

        //We reached the countvalue, stop updating
        } else {
            counter.innerText = parseFloat(target).toLocaleString('nl');
        }
    }

    countDecimals(num) {
        if(Math.floor(num.valueOf()) === num.valueOf()) return 0;
        return num.toString().split(".")[1].length || 0;
    }
}

new Counters